/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description toBuildingShortUrl
 */

export const toBuildingShortUrl = (buildingId: number) => `/buildings/${buildingId}` as const
